import { render } from "./StockMain.vue?vue&type=template&id=654e3a3a&scoped=true&ts=true"
import script from "./StockMain.vue?vue&type=script&lang=ts"
export * from "./StockMain.vue?vue&type=script&lang=ts"

import "./StockMain.vue?vue&type=style&index=0&id=654e3a3a&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654e3a3a"]])

export default __exports__